import { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button, Input, Label, Table } from "reactstrap";
import { getAdminCompany, getAdminCompanySim } from "../../slices/admin/thunk";
import { useDispatch, useSelector } from "react-redux";
import CompanyDropdown from "./CompanyDropdownMenu";
import AdminSimRow from "./AdminSimRow";
import AdminSimModal from "./AdminSimModal";

function AdminSim(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    document.title = t('PageMain.DocumentTitle');
    const simcard = useSelector(state => state.Admin.simcard);
    const companies = useSelector(state => state.Admin.company);
    const [searchWord, setSearchWord] = useState("");
    const [isShowModal, setShowModal] = useState(false);
    const [modalSim, setModalSim] = useState(null);
    const [isShowAll, setShowAll] = useState(false);
    const [companyID, setCompanyID] = useState(props.selectedCompany);

    async function fetchData() {
        dispatch(getAdminCompany(isShowAll));
        dispatch(getAdminCompanySim(isShowAll, companyID));
    }

    useEffect(() => {
        fetchData();
    }, [isShowAll, companyID])

    const handleSelect = (companyId) => {
        setCompanyID(companyId);
    };

    const handleCheckboxChange = (isChecked) => {
        setShowAll(isChecked);
    };

    return (
        <Fragment>
            <div className="d-flex flex-row align-items-start justify-content-between">
                <div className="d-flex flex-row align-items-start justify-content-start">
                    <Button size="sm" color="primary" className="mb-2 me-2" onClick={fetchData}>{t('Common.Btn.Refresh')}</Button>
                    <div className="mb-3">
                        <Input
                            name="searchWord"
                            className="form-control"
                            placeholder={t('Common.Btn.Search')}
                            type="text"
                            value={searchWord}
                            onChange={(event) => {
                                setSearchWord(event.target.value);
                            }}
                        />
                    </div>
                    <CompanyDropdown onChange={handleSelect} companyID={props.selectedCompany}/>
                     <div className="form-check ms-3 mt-1" >
                        <Input className="form-check-input" type="checkbox" checked={isShowAll} id="is-company-enabled-check"  onChange={(e) => handleCheckboxChange(e.target.checked)}/>
                        <Label className="form-check-label" htmlFor="is-company-enabled-check">{t('PageAdmin.Btn.DisplayDisabledSim')}</Label>
                    </div>
                </div>
                <Button size="sm" color="secondary" className="mb-2 me-2" onClick={() => { setModalSim(null); setShowModal(true); }}>{t('PageAdmin.Btn.CreateSim')}</Button>
            </div>


            <div className="device-table" style={{ maxHeight: '100%', overflowY: 'auto' }}>
                <Table className="table-nowrap mb-3">
                    <thead className="table-light sticky-header">
                        <tr>
                            <th scope="col">{t('PageAdmin.CompanySimTable.ID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.Name')}</th>
                            <th scope="col">{t('PageAdmin.CompanySimTable.SimCardNumber')}</th>
                            <th scope="col">{t('PageAdmin.CompanySimTable.PhoneNumber')}</th>
                            <th scope="col">{t('PageAdmin.CompanySimTable.VendorName')}</th>
                            <th scope="col">{t('PageAdmin.CompanySimTable.Status')}</th>
                            <th scope="col">{t('PageAdmin.CompanySimTable.CreatedAt')}</th>
                            <th scope="col">{t('PageAdmin.CompanySimTable.LastUpdatedAt')}</th>
                            <th scope="col">{t('PageAdmin.CompanySimTable.Action')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {companies.map(company => {
                            let scArray = simcard[company.id] || [];
                            return scArray
                                .filter(d => {
                                    if (searchWord === "") return true;
                                    return (
                                        d.phone_number.includes(searchWord) ||
                                        d.sim_card_number.includes(searchWord) ||
                                        d.vendor_name.includes(searchWord)
                                    );
                                })
                                .map(d => (
                                    <AdminSimRow
                                        data={d}
                                        key={d.id}
                                        companyName={company.name}
                                        onClickModify={() => {
                                            setModalSim(d); setShowModal(true);
                                        }}
                                    />
                                ));
                        })}
                        
                    </tbody>
                </Table>
                <AdminSimModal show={isShowModal} onCloseClick={(result)=>{setShowModal(false); if (result) { fetchData() }}} data={modalSim}/>
            </div>
        </Fragment>
    );
}

export default AdminSim;